"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
require("./FixedLeftFluidLayout.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var layoutClasses = (0, _cssClassesHelper.getBEMClasses)('fix-left-fluid-layout');
var FixedLeftFluidLayout = function FixedLeftFluidLayout(props) {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.showAccent && /*#__PURE__*/_react["default"].createElement("div", {
    className: layoutClasses('accent-bar')
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: layoutClasses('container')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: layoutClasses('side-bar')
  }, props.left), /*#__PURE__*/_react["default"].createElement("div", {
    className: layoutClasses('main')
  }, props.children)), /*#__PURE__*/_react["default"].createElement("div", {
    className: layoutClasses('footer')
  }, props.footer));
};
var _default = exports["default"] = FixedLeftFluidLayout;